
import { Vue, Component, Prop } from "vue-property-decorator";
import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";
import GET_CONTRACTOR_ACTIVITIES_WITH_PROJECTS from "@/apollo/projectActivities/GetContractorActivitiesWithProjects.gql";

import CardPagination from "@/components/card/PaginationNew.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import ProjectActivityForm from "@/entities/ProjectActivityForm";
import paginationConfig from "@/data/paginationConfig";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import ContractorActivityCardWithProject from "@/components/projects/activities/ContractorActivityCardWithProject.vue";
import ActivityFormModalNew from "@/components/projects/activities/ActivityFormModalNew.vue";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import { Project_Activity } from "@/generated/graphql";

@Component({
  components: {
    ContractorActivityCardWithProject,
    CardPagination,
    LoadingOverlay,
    EmptyListPlaceholder,
    EmptyListImageContractors,
    ActivityFormModalNew,
    NotesModal,
  },
  apollo: {
    activities: {
      query: GET_CONTRACTOR_ACTIVITIES_WITH_PROJECTS,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project_activity.length;
        return data.project_activity;
      },
    },
  },
})
export default class ContractorVisits extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;

  activities: any[] | null = null;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  
  showActivityForm = false;
  showNotes = false;
  selectedActivity: Project_Activity | null = null;

  get emptyListSubtitle(): string {
    return "This contractor has not been assigned to any visits yet.";
  }

  get activitiesArgs(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;

    return {
      offset: nextOffset,
      limit,
      where: {
        deleted: { _eq: false },
        contractor: {
          user: {
            id: {
              _eq: this.contractorUserId,
            },
          },
        },
      },
    };
  }
  
  showNotesModal(activity: Project_Activity) {
    this.selectedActivity = activity;
    this.showNotes = true;
  }
  
  closeNotesModal() {
    this.showNotes = false;
    this.selectedActivity = null;
  }
  
  editActivity(activity: Project_Activity) {
    this.selectedActivity = activity;
    this.showActivityForm = true;
  }
  
  closeActivityForm() {
    this.showActivityForm = false;
    this.selectedActivity = null;
  }
  
  onActivitySaved() {
    this.closeActivityForm();
    this.$apollo.queries.activities.refetch();
  }
}
